import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
//import { LocalStorageModule } from 'angular-2-local-storage'
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

    constructor(private common: CommonService,
        private http: HttpClient,
        private location: Location) { }


    //v2.1
    //LoginWithGoogle(credentials: string): Observable<any> {
    //    const header = new HttpHeaders().set('Content-type', 'application/json');
    //    return this.http.post(this.path + "LoginWithGoogle", JSON.stringify(credentials), { headers: header });
    //}

    return_url: any = {
        return: false,
        url: ""
    };

    _getAllAccounts(): any {
        return this.http.get(this.common.apiServiceURL + 'Account/getAccounts');

    }

    //

    _loginData: any = {
        loginType: '', //mobile, //email, //classic, //linkedin, //google, //facebook
        email: '',
        mobile: '',
        userType: 'new',
        firstName: '',
        lastName: ''
    }


    _authentication: any = {
        isAuth: false,
        userName: "",
        id: "",
        useRefreshTokens: false,
        token: "",
        isLoginAs: false,
        requesterLoginAsUser: {}
        
    };
    userData: any = {};
    


    getLinkedInProfileData(code: any) {
        return this.http.get(this.common.apiServiceURL + 'account/getLinkedInUserData?code=' + code);
    }
    getGoogleUserData(obj: any) {
        
        return this.http.post(this.common.apiServiceURL + 'account/getGoogleUserData', obj);
    }
    verifyMobileNumber(mobile: string): any {

        var obj = { "Mobile": mobile };
        return this.http.post(this.common.apiServiceURL + 'account/verifyMobileNumber', obj);
    }
    verifyEmailAddress(email: string): any {

        var obj = { "Email": email };
        return this.http.post(this.common.apiServiceURL + 'account/verifyEmailAddress', obj);
    }

    verifyOTP(obj: any): any {
        return this.http.post(this.common.apiServiceURL + 'account/verifyOTP', obj);
    }

    updateUserMobileNumber(obj: any): any {
        return this.http.post(this.common.apiServiceURL + 'account/updateUserMobileNumber', obj);
    }

    getUserIpLocation() {

        return this.http.get("https://ipapi.co/json/");
        //return this.http.get(this.rootScope.api + 'api/account/addUserPageView?notes=' + note + '&userId=' + this._authentication.userData.id + '&pageCode=' + pageCode)
        //  .map((response) => {
        //    return response.json();
        //});
    }

    verifyCaptcha(token: string) {
        var obj = {
            secret: "6LfwbMkUAAAAADZ702z4ZF8rLV82-OyakasSsM0i",
            response: token
        };
        return this.http.post("https://www.google.com/recaptcha/api/siteverify", obj);
    }

    //addPageView(PageCode: string, notes: string) {
    //  this._addUserPageView(PageCode, notes).subscribe(
    //    (res:any) => {

    //    },
    //    (err: any) => {
    //      console.log("addPageView Error", err);
    //    }
    //  );
    //}
    _register(registerObj: any) {
        return this.http.post(this.common.apiServiceURL + 'Account/UserRegister', registerObj);
    }

    _logout() {
        localStorage.removeItem('authorizationData');
        localStorage.removeItem('authorizationUserData');
        //this.rootScope.clearHubs();

        this._authentication.isAuth = false;
        this._authentication.userName = "";
        this._authentication.useRefreshTokens = false;
        this._authentication.id = "";
        this.userData = null;
        
    }

    addUserPageView(pageUrl: string, pagecode: string, module: string = ""): any {
        debugger;
        console.log("visited page", pageUrl + " " + this._authentication.id + " " + pagecode);
        
        this._addUserPageView(pagecode, "", pageUrl).subscribe((res: any) => { }, (err: any) => { });

        if (module == "") {
            module = pageUrl.split("/")[1];
            if (module === '') {
                module = "home";
            }
        }

        if (this.common.userMenus.length > 0) {
            this.common.getSubMenuItems(module, pagecode);
            this.common.setActiveModule(module);
        }
        else {
            this.getUserMenu(this._authentication.id, this._authentication.userName, pagecode, module);
        }
        
        
        //this.common.setActiveMenu(pagecode);

    }
    getUserMenu(userId: string, emailAddress: string, pagecode: string, module: string = "") {
        this.common.getUserModulesAndMenus(userId, emailAddress).subscribe(
            (res: any) => {

                this._setLocalStorage('authorizationUserData', JSON.stringify(res["data"].userData));
                this.userData = res["data"].userData;
                this.common.SideBarMenu = [];
                for (var i = 0; i < res["data"].userModules.length; i++) {
                    if (!res["data"].userModules[i].isIWantToMenu) {
                        this.common.SideBarMenu.push({
                            path: res["data"].userModules[i].navigateURL,
                            title: res["data"].userModules[i].moduleName,
                            icon: res["data"].userModules[i].iconCSS,
                            type: "link",
                            code: res["data"].userModules[i].moduleCode,
                            active: false,
                            showTopAds: res["data"].userModules[i].showTopAds
                        });
                    }
                }
                for (var i = 0; i < res["data"].userSubMenus; i++) {
                    res["data"].userSubMenus[i].isActiveMenu = false;
                }
                this.common.userMenus = res["data"].userSubMenus;
                this.common.IWantToMenu = res["data"].userIWantToMenu;
                this.common.setActiveModule(module);
                this.common.getSubMenuItems(module, pagecode);

            },
            (err: any) => { });
    }
    _addUserPageView(pageCode: string, note: string, pageUrl: string): any {

        return this.http.get(this.common.apiServiceURL + 'account/addUserPageViewV2?pageUrl=' + pageUrl + '&notes=' + note + '&userId=' + this._authentication.id + '&pageCode=' + pageCode);
    }

    addUserLogin(userAddress: any): any {
        return this.http.get(this.common.apiServiceURL + 'account/addUserLogin?ip=' + userAddress.ip +
            '&city=' + userAddress.city +
            '&countryName=' + userAddress.country_name +
            '&country=' + userAddress.country +
            '&calling_code=' + userAddress.country_calling_code +
            '&currency=' + userAddress.currency +
            '&latitude=' + userAddress.latitude +
            '&longitude=' + userAddress.longitude +
            '&org=' + userAddress.org +
            '&region=' + userAddress.region +
            '&region_code=' + userAddress.region_code +
            '&timezone=' + userAddress.timezone +
            '&utc_offset=' + userAddress.utc_offset +
            '&userId=' + this._authentication.userData.id);
    }

    _addUserLogin() {

        this.getUserIpLocation().subscribe(
            (res: any) => {
                let userAddress: any = res;
                this.addUserLogin(userAddress).subscribe(
                    (res: any) => { },
                    (err: any) => { console.error("addUserLogin", err); }
                )

            },
            (err: any) => {
                console.error("getUserIpLocation", err);
            });
    }

    _userAuthentication(data: any): any {
        let headers: Headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' });
        return this.http.post(this.common.apiServiceURL + 'token', data);
    }

    _getLoggedPortalUser(loginData: any): any {
        return this.http.get(this.common.apiServiceURL + 'Account/getPortalUserByEmail?emailAddress=' + loginData.userName);

    }

    _getPortalUserById(userId: string) {
        return this.http.get(this.common.apiServiceURL + 'Account/getPortalUserById?Id=' + userId);
    }

    _login(loginData: any): any {
        return this.http.get(this.common.apiServiceURL + 'Account/login?password=' + loginData.password + '&username=' + loginData.userName);
    }
    _loginAs(loginData: any): any {
        return this.http.get(this.common.apiServiceURL + 'Account/loginAs?userEmail=' + loginData.user_userName +'&password=' + loginData.password + '&username=' + loginData.userName);
    }
    _adminLogin(loginData: any): any {
        return this.http.get(this.common.apiServiceURL + 'Account/adminLogin?clientUsername=' + loginData.clientUsername + '&password=' + loginData.password + '&username=' + loginData.userName);

    }

    _setLocalStorage(key: string, value: any) {
        localStorage.setItem(key, value);
    }

    _getLocalStorage(key: string): any {
        //var authorizationData = localStorage.getItem(key);
        //console.log(key, authorizationData);
        return JSON.parse(localStorage.getItem(key)!);
    }

    _fillAuthData(authData: any): any {

        //this._authentication.isAuth = true;
        //this._authentication.userName = authData.userName;
        //this._authentication.useRefreshTokens = authData.useRefreshTokens;
        //this._authentication.userData = authData.userData;

        //this._addUserLogin();

        //this.rootScope.loadData.support.sfAccountName = authData.userData.portalAccount.name;
        //this.rootScope.loadData.support.sfAccountID = authData.userData.sfAccountID;
        //this.rootScope.loadData.support.sfContactEmail = authData.userData.eMail;
        //this.rootScope.loadData.support.sfContactName = authData.userData.firstName + ' ' + authData.userData.lastName;

        //this.rootScope.loadData.services.sfAccountName = authData.userData.portalAccount.name;
        //this.rootScope.loadData.services.sfAccountID = authData.userData.sfAccountID;
        //this.rootScope.loadData.services.sfContactEmail = authData.userData.eMail;
        //this.rootScope.loadData.services.sfContactName = authData.userData.firstName + ' ' + authData.userData.lastName;
        //this.rootScope.loadData.services.sfContactID = authData.userData.sfContactId;

        //this.getRoleMapping(this._authentication.userData.roleId);
    }

    getRoleMapping(roleId: number): any {
        return this.http.get(this.common.apiServiceURL + 'account/getRoleActionsMapping?roleId=' + roleId);
    }

    applySecurity(roleMappingObj: any) {
        //for (let i = 0; i < roleMappingObj.length; i++) {
        //  this.rootScope.Security[roleMappingObj[i].portalActions.code] = roleMappingObj[i].hasAccess;
        //}
        //console.log("Security", this.rootScope.Security);
    }

    _checkVerificationCode(email: string, code: string): any {
        return this.http.get(this.common.apiServiceURL + 'account/CheckVerificationCode?emailAddress=' + email + '&code=' + code);
    }


    _resetPassword(emailAddress: string): any {
        return this.http.get(this.common.apiServiceURL + 'account/ResetPassword?emailAddress=' + emailAddress);
    }

    _sendPassword(emailAddress: string, code: string): any {
        return this.http.get(this.common.apiServiceURL + 'account/SendPassword?emailAddress=' + emailAddress + '&code=' + code);
    }

    _changePassword(password: string, emailAddress: string): any {
        return this.http.get(this.common.apiServiceURL + 'account/ChangePasswordByEmail?emailAddress='
            + emailAddress + '&CurrentPassword='
            + password + '&NewPassword='
            + password);
    }

    _getUserNotification(userId: string) {
        return this.http.get(this.common.apiServiceURL + 'Message/getUserNotifications?userId=' + userId);
    }

    _getNotificationItem(id: string) {
        return this.http.get(this.common.apiServiceURL + 'Message/getNotificationItem?id=' + id);
    }

    checkUserPageAccess(userId: string, pageCode: string) {
        return this.http.get(this.common.apiServiceURL + 'account/checkUserPageAccess?userId=' + userId + '&pageCode=' + pageCode);
    }
}
